import { Component, ViewChild, OnInit, EventEmitter } from '@angular/core';
import { TranslationsService } from '../../core/translations/translations.service';
import { AppStorageService } from "../../app.storage.service";
import { FranchiseService } from '../../core/services/franchise.service';
import { DeliveryGuyService } from '../../core/services/delivery-guy.service';
import { OrderAppModel } from '../../models/order/order-app.model';
import { environment } from '../../../environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DeviceDetectorService } from 'ngx-device-detector';
import { StorageValueEnum } from '../../enums/advanced/storage-value.enum';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { datepickerAnimation } from 'ngx-bootstrap/datepicker/datepicker-animations';
import { ElectronService } from 'ngx-electron';
import { url } from 'inspector';

// declare var electron: any;

@Component({
  selector: 'app-franchise',
  templateUrl: './franchise.component.html',
  styleUrls: ['./franchise.component.css']
})
export class FranchiseComponent implements OnInit {
 // @ViewChild('cancelOrderModal', { static: false }) public cancelOrderModal: ModalDirective;

  private deviceInfo: any;
  private soundUrl: string;
  //private itemsShowLimit: number;
  private userColumnsKey: string;
  private userSavedColumns: any[];
  public franchises: any[];
  public currentFranchise:any;
  public deliveryGuys: [];
  public filterQuery = '';
  public fieldsToFilter: string[] = ['Id', 'Name'];
  public selectedOrderStatusId: number;
  public showDetailsRow: boolean = false;
  public expandedIndex: number;
  
  public franchiseToDelete: any;
  public fromDate: Date;
  public lastOrderId: number;

  public dropdownColumnsList = [];
  public selectedColumns = [];
  public dropdownSettings: IDropdownSettings = {};
  public colspan: number;
  public isCollapsed: boolean = true;
  public imageVersion: string;

  constructor(private translationService: TranslationsService,
    private franchiseService: FranchiseService,
    private deliveryGuyService: DeliveryGuyService,
    private deviceService: DeviceDetectorService,
    public appStorageService: AppStorageService) {
;
  }

  ngOnInit(): void {
    this.imageVersion = this.getGuid();
    this.deviceInfo = this.deviceService.getDeviceInfo();   
    this.expandedIndex = -1;
    this.appStorageService.displaySideBar=false;
    this.appStorageService.franchise = undefined;
    this.appStorageService.branch = undefined;
    this.getAllFranchises();
  }

  S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }

  getGuid() {
    return (this.S4() + this.S4() + "-" + this.S4() + "-4" + 
            this.S4().substr(0, 3) + "-" + this.S4() + "-" + 
            this.S4() + this.S4() + this.S4()).toLowerCase();
  }

  isMobileMode(): boolean {
    return this.deviceService.isMobile();
  }
  onItemSelect(item: any) {
    //console.log(item);

  }
  onSelectAll(items: any) {
    // console.log(items);

  }

  getPaymentType(order: OrderAppModel): string {
    if (order.PaymentTypeId == 6) {
      return this.translationService.translate('INCOMEORDERS.CREDIT');
    } //else if (order.PaymentType !== 'Unknown') {
      //return "";
    //} 
    else {
      return order.PaymentTypeStr;
    }
  }

   
  

  public getAllFranchises() {
    console.log('getAllFranchises');
    this.franchiseService.getAllNew().subscribe((response) => {
      if (response) {
        console.log('getAllFranchises', response);
        this.franchises = response;
        //this.deliveryGuys = _.filter(response, row => row.ShowInList == true);
        console.log('franchises', this.franchises);
      }
    }, error => {
      console.log('getAllFranchises - Error', error);
    });
  }


  public stringedDateFomat(stringedDate) {
    let timeArr = stringedDate.split(' ')[1].split(':');
    var strTime = '';

    var hours = +timeArr[0];
    var minutes = +timeArr[1];
    var hoursStr: String;
    var minutesStr: String;


    if (environment.language == 'en') {
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutesStr = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
      strTime = hours + ':' + minutesStr + ' ' + ampm;
    } else {
      hoursStr = hours < 10 ? '0' + hours.toString() : hours.toString();
      minutesStr = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
      strTime = hoursStr + ':' + minutesStr;
    }

    return strTime;
  }


  delete() {
    this.franchiseService.delete(this.franchiseToDelete.Id).subscribe((response) => {
      if (response) {
        console.log('delete', response);
        this.getAllFranchises();
        
      }
    }, error => {
      console.log('delete - Error', error);
    });
  }

  expandRow(index: number, franchise): void {
   
    this.currentFranchise = franchise;
    this.appStorageService.franchise = franchise;
    this.expandedIndex = index === this.expandedIndex ? -1 : index;
  }

  setCurrentFranchise(franchise) {
    this.currentFranchise = franchise;
    this.appStorageService.franchise = franchise;
  }


   

   
 

  
}

